import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface StatItem {
  label: string;
  value: string;
  icon: string;
  color: string;
}

const FeedbackStats = () => {
  const stats: StatItem[] = [
    {
      label: 'Retroalimentaciones Totales',
      value: '1,247',
      icon: 'ChatBubbleLeftRightIcon',
      color: 'text-primary',
    },
    {
      label: 'Calificación Promedio',
      value: '4.6/5',
      icon: 'StarIcon',
      color: 'text-accent',
    },
    {
      label: 'Tiempo de Respuesta',
      value: '24h',
      icon: 'ClockIcon',
      color: 'text-secondary',
    },
    {
      label: 'Tasa de Satisfacción',
      value: '92%',
      icon: 'FaceSmileIcon',
      color: 'text-success',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg shadow-elevation-sm p-6 space-y-3 hover:shadow-elevation-md transition-smooth"
        >
          <div className="flex items-center justify-between">
            <Icon name={stat.icon as any} size={24} className={stat.color} />
            <span className="caption text-muted-foreground">
              {stat.label}
            </span>
          </div>
          <p className="text-2xl font-heading font-semibold text-foreground">
            {stat.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default FeedbackStats;